var map = {
	"./768_stores_img1.png": "c088",
	"./768_stores_img2.png": "e7ca",
	"./768_stores_img3.png": "3b05",
	"./768_stores_img4.png": "f471",
	"./768_stores_img5.png": "8d66",
	"./768_stores_img6.png": "5480",
	"./768_stores_img7.png": "3fcd",
	"./768_stores_img8.png": "6ce7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e8d8";